import React, { useContext, useEffect } from 'react';
import { FormTextArea, FormInput, Row } from '@digital/ui';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import * as Yup from 'yup';
import { EGuidModalComentario } from '@app/enums/EGuidModalComentario';
import ModalComentariosCampoDemanda from '../../analise/ModalComentariosCampoDemanda';
import ModalComentariosAnexoFormularioReqCompra from '../ModalComentariosAnexoFormularioReqCompra';

interface IRequisicaoCompraObjetoJustificativaProps {
  forceDisabled?: boolean;
}

const RequisicaoCompraObjetoJustificativa = ({ forceDisabled }: IRequisicaoCompraObjetoJustificativaProps) => {
  const { statusCodigo, statusPrazo, statusPrazoExtenso, demandaData, anexoFormularioReqCompra, getAnexoFormularioReqCompra } = useContext(QuestionarioContextProvider);

  useEffect(() => {
    async function fetchData() {
      await getAnexoFormularioReqCompra(demandaData && demandaData.id);
    }
    if (demandaData && (demandaData.capex || demandaData.contaResultado)) {
      fetchData();
    }
  }, [demandaData]);
  
  return (
    <>
      {statusCodigo == 2 ? (
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ color: 'rgb(105,105,105' }}>
            Sua documentação será validada e/ou comentada em até {statusPrazo} ({statusPrazoExtenso}) dias úteis.
          </h3>
        </div>
      ) : (
        <>
          <Row>
            <FormTextArea
              id="mrn-textarea-objetoASerContratado"
              name="objeto"
              label="Objeto a Ser Contratado"
              span={12}
              rows={1}
              disabled={forceDisabled}
            />
          </Row>
          <Row>
            <FormTextArea
              id="mrn-textarea-justificativaRequisicaoCompra"
              label="Justificativa da Contratação"
              name="justificativaRequisicaoCompra"
              span={12}
              rows={1}
              disabled={forceDisabled}
            />
          </Row>
          <Row>
            <FormInput
              id="mrn-input-localDeExecucao"
              label="Local de Execução"
              name="localDeExecucao"
              span={12}
              disabled={forceDisabled}
            />
          </Row>
          {
            demandaData &&
            demandaData.isModificando &&
            <Row>
              {
                demandaData.opex &&
                <ModalComentariosCampoDemanda
                  idDoComponente='mrn-modal-ModalComentariosCampoDemanda'
                  campoId={EGuidModalComentario.ESCLARECIMENTO_PREVISAO_ORCAMENTARIA}
                  demandaId={demandaData!.id || ''}
                  key={demandaData!.id}
                  preSuprimentos={false}
                  ehTelaDemandante={true}
                />
              }

              {
                (demandaData.capex || demandaData.contaResultado) &&
                anexoFormularioReqCompra &&
                anexoFormularioReqCompra.length &&
                <ModalComentariosAnexoFormularioReqCompra
                  preSuprimentos={false}
                  anexoId={anexoFormularioReqCompra[0].id}
                  contemComentario={anexoFormularioReqCompra[0].contemComentarios || false}
                />
              }
            </Row>
          }
        </>
      )}
    </>
  );
};

export default RequisicaoCompraObjetoJustificativa;
